import raf            from 'raf';

/**
 * This function handles will attach a video modal trigger
 * to all links that have the `data-video-id` attribute added
 */

function videoTrigger(el, app) {

    const $body = $('body');
    const $el = $(el);
    const videoId = $el.data('video-id');
    const videoUrl = $el.data('video-url');
    // const videoSource = $el.data('video-source');
    let   aspectRatio = $el.data('video-aspect');
    let   maxWidth = $el.data('video-max-width');


    // const videoUrl = () => {
    //     switch( videoSource ){

    //         case 'YouTube':
    //             return `https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0;autoplay=1&rel=0&hl=sv&modestbranding=1`;
    //         case 'MediaFlow':
    //             return `#${videoId}`;
    //         default:
    //             throw new Error( `Unknown video source: '${videoSource}'`)

    //     }
    // }

    /**
     * click handler that triggers the modal
     */
    const openVideoModal = function(evt) {
        evt.preventDefault();

        // First create the html structure.
        let $content = $('<div>', {
            'id'                    : 'video' + videoId,
            'class'                 : 'Ge-Popup',
            'data-js-popup'         : '',
            'data-popup-noclose'    : '',
            'data-popup-width'      : (Number.isInteger(parseInt(maxWidth)) ? maxWidth + '' : '1200')
        });

        let $detail = $('<div>',{
            'class'                 : 'Ge-Popup-Detail Ge-Popup-Detail--video Ge-ModalVideo Ge-ModalVideo--loading-background-black',
            'data-js-popup-detail'  : ''
        });

        $content.append($detail);

        if (aspectRatio) {
            $detail.addClass('Ge-ModalVideo--' + aspectRatio);
        }

        let spinner = $(`<span class="Ge-Spinner Ge-Spinner--center Ge-Spinner--white" aria-hidden="false">
            <span class="Ge-Spinner-bounce Ge-Spinner-bounce-1"></span>
            <span class="Ge-Spinner-bounce Ge-Spinner-bounce-2"></span>
            <span class="Ge-Spinner-bounce Ge-Spinner-bounce-3"></span>
        </span>`);

        let close = $(`<a class="Ge-ModalVideo-Close Ge-ModalVideo-Close--Hidden" data-js-popup-close><svg viewBox="0 0 512 512" class="Ge-Icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-stop"></use></svg></a>`);

        let iframe = $('<iframe>', {
            'class'             : 'Ge-ModalVideo-Embed Ge-ModalVideo-Embed--Hidden',
            'src'               : '',
            'frameborder'       : '0',
            'allowfullscreen'   : 'allowfullscreen'
        })

            // show the modal when it's loaded to prevent seeing unloaded stuff.
            .on('load', () => {
                spinner.remove();
                iframe.removeClass('Ge-ModalVideo-Embed--Hidden');
            });

        $detail
            .append(spinner)
            .append(iframe)
            .append(close);

        $body.append($content);


        // notify other methods that the pop-up is ready
        raf(function tick1() {
            raf(function tick2() {
                app.on('popComplete',function videoModalReady (ev) {
                    // $('.Ge-Popup-Shell--active').find('iframe').attr('src',`https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0;autoplay=1&rel=0&hl=sv&modestbranding=1`);
                    $('.Ge-Popup-Shell--active').find('iframe').attr('src',videoUrl);
                    app.on('popComplete',videoModalReady);
                });
                // send it over to the global modal functionality.
                app.trigger('popPop',{ popupTarget: '#video' + videoId });
                // ga
                app.trigger('beacon','movie-open-card,' + videoId);
                // remove the temp content
                $('body > #video' + videoId).remove();
            });
        });

    };

    $el.click(openVideoModal);
    return {};
};

videoTrigger.selector = '[data-video-id]';
export default videoTrigger;
